import PropTypes from 'prop-types';
import { deprecated } from '../../utils/prop-types/deprecated';
export const audiPlatformProviderPropTypes = {
    theme: PropTypes.object,
    rootSelector: deprecated('^2.0.0'),
};
//# sourceMappingURL=PlatformProvider.types.js.map